import React from "react";
import { NavigationHelper } from "../helpers";
import { NewMessageType } from "./components/NewMessageType";

export const MessagesPage: React.FC = () => {

  const [shape, setShape] = React.useState("");
  const [showMore, setShowMore] = React.useState(false);

  React.useEffect(() => { setTimeout(NavigationHelper.showMobileSidebar, 10) }, []) // eslint-disable-line

  const getContents = () => {
    if (shape) return <NewMessageType shape={shape} />
    else return getChooseLayout();
  }

  const getMore = () => {
    if (showMore) {
      return (
        <div className="layout-more-section">
          <h4>Specialty Layouts</h4>
          <div className="layout-specialty-options">
            <a href="about:blank" onClick={(e) => { e.preventDefault(); setShape("4:1"); }} className="layout-specialty-link" data-testid="layout-specialty-4-1">
              <i className="fas fa-rectangle-wide"></i>
              <span>4:1 Three Zone Template</span>
            </a>
          </div>
        </div>
      )
    }
    else return (
      <button onClick={() => setShowMore(true)} className="layout-more-btn">
        More options <i className="fas fa-chevron-down"></i>
      </button>
    );
  }

  const getChooseLayout = () => {
    return (
      <div className="layout-selection">
        <p className="layout-instruction">Select your screen layout to get started</p>
        <div className="layout-options">
          <a href="about:blank" onClick={(e) => { e.preventDefault(); setShape("16:9"); }} className="layout-option" data-testid="layout-horizontal-16-9">
            <div className="layout-preview horizontal">
              <img src="/images/screenH.png" alt="Horizontal 16:9" />
            </div>
            <span className="layout-label">Horizontal</span>
            <span className="layout-ratio">16:9</span>
          </a>

          <a href="about:blank" onClick={(e) => { e.preventDefault(); setShape("9:16"); }} className="layout-option" data-testid="layout-vertical-9-16">
            <div className="layout-preview vertical">
              <img src="/images/screenV.png" alt="Vertical 9:16" />
            </div>
            <span className="layout-label">Vertical</span>
            <span className="layout-ratio">9:16</span>
          </a>
        </div>
        {getMore()}
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1><i className="far fa-image"></i> New Message</h1>
        <p className="page-subtitle">Create content for your digital signage displays</p>
      </div>
      {getContents()}
    </div>
  );
};